import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { FunnelIcon } from '@phosphor-icons/react';
import type { WorkflowStep } from '@erp/shared-types';
import { WORKFLOW_STEP_FILTER_OPTIONS } from '@/hooks/useWorkflowStepFilter';

interface WorkflowStepFilterProps {
  selectedWorkflowStep: WorkflowStep | 'all';
  onWorkflowStepChange: (workflowStep: WorkflowStep | 'all') => void;
  className?: string;
}

export function WorkflowStepFilter({
  selectedWorkflowStep,
  onWorkflowStepChange,
  className = '',
}: WorkflowStepFilterProps) {
  const selectedOption =
    WORKFLOW_STEP_FILTER_OPTIONS.find(
      (option) => option.value === selectedWorkflowStep,
    ) || WORKFLOW_STEP_FILTER_OPTIONS[0];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <FunnelIcon className="h-4 w-4 text-gray-500" />
      <Select
        value={selectedWorkflowStep}
        onValueChange={(value) =>
          onWorkflowStepChange(value as WorkflowStep | 'all')
        }
      >
        <SelectTrigger className="w-48">
          <SelectValue>
            <div className="flex items-center gap-2">
              {selectedOption.color && selectedWorkflowStep !== 'all' && (
                <Badge
                  variant="secondary"
                  className={`${selectedOption.color} text-xs`}
                >
                  {selectedOption.label}
                </Badge>
              )}
              {selectedWorkflowStep === 'all' && (
                <span className="text-sm">{selectedOption.label}</span>
              )}
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {WORKFLOW_STEP_FILTER_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              <div className="flex items-center gap-2">
                {option.color && option.value !== 'all' && (
                  <Badge
                    variant="secondary"
                    className={`${option.color} text-xs`}
                  >
                    {option.label}
                  </Badge>
                )}
                {option.value === 'all' && (
                  <span className="text-sm">{option.label}</span>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
